import { AxiosError } from 'axios';

export interface ApiErrorResponse {
  message?: string;
  errorMessage?: string;
  violations?: Array<{ fieldName?: string; message: string }>;
}

/**
 * Извлекает сообщение об ошибке из ответа API.
 * Поддерживает формат violations (например, 400 от refund).
 */
export function getErrorMessageFromAxiosError(error: unknown): string {
  const axiosError = error as AxiosError<ApiErrorResponse>;
  const data = axiosError.response?.data;

  if (data?.violations?.length) {
    const messages = data.violations.map((v) => v.message).filter(Boolean);
    if (messages.length) {
      return messages.join('\n');
    }
  }

  return (
    data?.errorMessage ||
    data?.message ||
    axiosError.message ||
    'An unknown error occurred'
  );
}
